import { $Q, $Qll } from "../utils/query-selector";

/**
 * The function initializes a slider with specific settings and mounts it on the page if a certain
 * element exists.
 */
const initTrustSlider = () => {
  if ($Q("#trustSlider")) {
    new Splide("#trustSlider", {
      type: "loop",
      perPage: 4,
      perMove: 1,
      rewind: true,
      autoplay: true,
      arrows: false,
      pagination: false,
      speed: 1000,
      interval: 2000,
      breakpoints: {
        768: {
          perPage: 3,
        },
      },
    }).mount();
  }
};


/**
 * The function initializes a slider with autoplay, pagination, and slide functionality.
 */
const initNumbersSlider = () => {
  if ($Q("#numbersSlider")) {
    new Splide("#numbersSlider", {
      type: "slide",
      rewind: true,
      perPage: 1,
      autoplay: true,
      arrows: false,
      pagination: true,
      gap: "28px",
      padding: { left: 24, right: 24 },
      breakpoints: {
        1025: {
          perPage: 3,
          loop: true
        },
        768: {
          perPage: 2,
          loop: true
        },
        576: {
          perPage: 1,
        },
      }
    }).mount();
  }
};

/**
 * This function initializes a slider with autoplay, pagination, and slide functionality for a specific
 * element with the ID "cardsLinksSlider".
 */
const initCardsLinksSlider = () => {
  if ($Q("#cardsLinksSlider")) {
    new Splide("#cardsLinksSlider", {
      type: "slide",
      rewind: true,
      perPage: 2,
      autoplay: true,
      arrows: false,
      pagination: true,
      gap: "1rem",
      breakpoints: {
        640: {
          perPage: 1,
        },
      }
    }).mount();
  }
};

/**
 * This function initializes a slider with autoplay, pagination, and slide functionality for a specific
 * element with the ID "stickyCardsSlider".
 */
const initStickyCardsSlider = () => {
  if ($Q("#stickyCardsSlider")) {
    new Splide("#stickyCardsSlider", {
      type: "slide",
      rewind: true,
      perPage: 1,
      autoplay: true,
      arrows: false,
      pagination: true,
      gap: "1rem"
    }).mount();
  }
};

/**
 * The function initializes a testimonials slider using the Splide library with specific settings.
 */
const initTestimonialsSlider = () => {
  if ($Q("#testimonialsSlider")) {
    new Splide("#testimonialsSlider", {
      type: "slide",
      rewind: true,
      perPage: 1,
      autoplay: true,
      arrows: true,
      pagination: true,
      gap: "1rem"
    }).mount();
  }
};

/**
 * This function initializes a slider for a set of cards with images, allowing for sliding, autoplay,
 * pagination, and responsive breakpoints.
 */
const initCardsImagesSlider = () => {
  if ($Q("#cardsImagesSlider")) {
    new Splide("#cardsImagesSlider", {
      type: "slide",
      rewind: true,
      perPage: 3,
      autoplay: true,
      arrows: false,
      pagination: true,
      gap: "2rem",
      breakpoints: {
        768: {
          perPage: 2,
        },
        640: {
          perPage: 1,
        },
      }
    }).mount();
  }
};

/**
 * The function initializes a slider with specific settings for search results.
 */
const initSearchResultsSlider = () => {
  const settings = {
    type: "slide",
    rewind: true,
    perPage: 3,
    autoplay: true,
    arrows: false,
    pagination: true,
    gap: "2rem",
    breakpoints: {
      768: {
        perPage: 2,
      },
      640: {
        perPage: 1,
      },
    }
  };

  if ($Q("#post-Slider")){
    new Splide("#post-Slider", settings).mount();
  }
  if ($Q("#event-webinar-Slider")){
    new Splide("#event-webinar-Slider", settings).mount();
  }
  if ($Q("#resource-center-Slider")){
    new Splide("#resource-center-Slider", settings).mount();
  }
  
}

export { 
  initTrustSlider,
  initNumbersSlider, 
  initCardsLinksSlider, 
  initStickyCardsSlider, 
  initTestimonialsSlider, 
  initCardsImagesSlider,
  initSearchResultsSlider,
};
